import type { AIDecorationExperiencePluginState } from '../reducer';

export const hasGeneratedContentDecorations = (state: AIDecorationExperiencePluginState) =>
	state.modalDecorationSet.find(
		undefined,
		undefined,
		(spec) =>
			spec.key === 'generatedInlineDecoration' ||
			// TODO: AI Button experiment cleanup - platform_editor_ai_ai_button_block_elements
			spec.key === 'generatedNodeDecoration' ||
			spec.key === 'generatedStartWidget' ||
			spec.key === 'generatedEndWidget',
	).length > 0;
